/**
 * Register Page
 *
 * Redirects to the Request Access page since tenant registration
 * now requires platform admin approval.
 *
 * Note: The old self-registration flow has been replaced with the
 * approval-based workflow for better security and control.
 */

import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

export const RegisterPage: React.FC = () => {
  // Redirect to the new request-access page
  return <Navigate to="/request-access" replace />;
};

export default RegisterPage;
